import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getOnlineRegistration } from '../Service/Api';
import LazyLoad from 'react-lazyload';

const OnlineRegistration = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const getData = async () => {
      try {
        const registrationData = await getOnlineRegistration();
        setData(registrationData || []);
      } catch (error) {
        console.error('Error fetching registration data:', error);
      }
    };

    getData();
  }, []);

  return (
    <>
      {data.length > 0 &&
        data.map((item, index) => (
          <div key={index} className="OnlineR">
            <span
              className="bounce1"
              style={{ display: item ? 'block' : 'none' }}
            >
              {item.url && (
                <Link
                  to={item.url}
                  target="_blank"
                  className="parantlogo"
                  rel="noopener noreferrer"
                >
                  <LazyLoad>{item.title}</LazyLoad>
                </Link>
              )}

              {item.attachments &&
  ((Array.isArray(item.attachments) && item.attachments.length > 0) ||
   (typeof item.attachments === "string" && item.attachments.trim() !== "")) && (
    <Link
      to={`https://webapi.entab.info/api/image/${Array.isArray(item.attachments) ? item.attachments[0] : item.attachments}`}
      target="_blank"
      className="parantlogo-attachment"
      rel="noopener noreferrer"
    >
      <i className="bi bi-paperclip"></i>
    </Link>
  )}
            </span>
          </div>
        ))}
    </>
  );
};

export default OnlineRegistration;
